<div class="container_alert" >
  <div class="conteiner_alert__icon">
    <img src="../../../../assets/icons/danger-white.svg" alt="">
  </div>
  <div class="conteiner_alert__content">
    <p>Procedimentos e solicitações de oncologia necessitam de perícia médica</p>
  </div>
</div>
